/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beautify, minify and validate JSON right in your browser. Paste your JSON to pretty-print it with your chosen indentation, or minify it to a single line.`)
};

const es_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embellecer, minificar y validar JSON directamente en tu navegador. Pega tu JSON para embellecherlo con tu indentación elegida, o minifícalo en una sola línea.`)
};

const de_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatieren, minimieren und validieren Sie JSON direkt in Ihrem Browser. Fügen Sie Ihr JSON ein, um es mit Ihrer gewählten Einzugstiefe schön zu formatieren, oder minimieren Sie es auf eine Zeile.`)
};

const nl_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak JSON mooi, minimaliseer het en valideer het rechtstreeks in je browser. Plak je JSON om het mooi af te drukken met je gekozen inspringing, of minimaliseer het tot een enkele regel.`)
};

const fr_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embellissez, minifiez et validez du JSON directement dans votre navigateur. Collez votre JSON pour l'embellir avec l'indentation de votre choix, ou minifiez-le en une seule ligne.`)
};

const it_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatta, minimizza e valida JSON direttamente nel tuo browser. Incolla il tuo JSON per formattarlo con l'indentazione scelta, o minimizzalo in una sola riga.`)
};

const pt_br2_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeleze, minifique e valide JSON diretamente no seu navegador. Cole seu JSON para formatá-lo com a indentação escolhida ou minifique-o para uma única linha.`)
};

const pt_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeleze, minifique e valide JSON diretamente no seu navegador. Cole o seu JSON para formatá-lo com a indentação à sua escolha, ou minifique-o para uma única linha.`)
};

const ja_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONをブラウザ内でbeautify、minify、検証します。JSONを貼り付けて、選択したインデンテーションで美化するか、1行にminifyします。`)
};

const zh_jf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直接在浏览器中美化、压缩并验证 JSON。粘贴您的 JSON，即可按所选缩进方式进行美化，或将其压缩为单行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_intro", locale)
	if (locale === "en") return en_jf_intro(inputs)
	if (locale === "es") return es_jf_intro(inputs)
	if (locale === "de") return de_jf_intro(inputs)
	if (locale === "nl") return nl_jf_intro(inputs)
	if (locale === "fr") return fr_jf_intro(inputs)
	if (locale === "it") return it_jf_intro(inputs)
	if (locale === "pt-BR") return pt_br2_jf_intro(inputs)
	if (locale === "pt") return pt_jf_intro(inputs)
	if (locale === "ja") return ja_jf_intro(inputs)
	return zh_jf_intro(inputs)
};